import image from "../assets/joists.webp";
import DESIGNPINELOGO from "../assets/design-pine-logo.webp";
import { useEffect } from "react";
import $ from "jquery";

const Joists = () => {
  useEffect(() => {
    $("#rafterSubmit").on("click", function () {
      getSelectedOption();
    });
    function getSelectedOption() {
      var list = $("#list1");
      var list2 = $("#list2");
      var list3 = $("#list3");
      // eslint-disable-next-line
      var list4 = $("#list4");
      var x = document.getElementById("myDIV");
      var errorMessage = document.getElementById("errorMessage");

      if (list.val() === "") {
        errorMessage.style.display = "block";
        errorMessage.innerHTML = "Please Select Span Type";
        $("#list1").focus();
        return false;
      } else if (list2.val() === "") {
        errorMessage.style.display = "block";
        errorMessage.innerHTML = "Please Select Live Load";
        $("#list2").focus();
        return false;
      } else if (list3.val() === "") {
        errorMessage.style.display = "block";
        errorMessage.innerHTML = "Please Select Joist Centre";
        $("#list3").focus();
        return false;
      } else {
        errorMessage.style.display = "none";
        x.style.display = "block";
        var spantype = list.val();
        var windzone = list2.val();
        var roofload = list3.val();
        var desiredspan = document.getElementById("desiredSpan").value;

        $("#myDIV").load(displayInfo(spantype, windzone, roofload, desiredspan));

        return true;
      }
    }

    function displayInfo(opt1, opt2, opt3, opt4) {
      var spantype = opt1;
      var windzone = opt2;
      var roofload = opt3;
      var desiredspan = opt4;
      // eslint-disable-next-line
      var setLink =
        "https://spantablesviewer.azurewebsites.net/joists?brandname=DesignPine" +
        "&spantype=" +
        spantype +
        "&liveload=" +
        windzone +
        "&joistcentre=" +
        roofload +
        "&desiredspan=" +
        desiredspan;

      $.ajax({
        url: setLink,
        type: "GET",
        dataType: "text",
        success: function (response) {
          $("#Loading").hide();
          if (response.length === 0) {
            document.getElementById("yellowAlert").style.display = "block";
            document.getElementById("reportButton").style.display = "none";
            document.getElementById("tableShell").style.display = "none";

            document.getElementById("showResult").innerHTML = "No result Found";
          } else {
            $("#list-rafter").empty();
            var clearHTML =
              '        <tr>          <td data-label="Size"><span id="BeamSize"></span></td>          <td data-label="Grade"><span id="strength" data-strength=""></span></td>          <td data-label="Span (mm)"><span id="span" data-span=""></span></td>          <td data-label="Select">            <label className="toggle-check">              <input id="reportCheckbox" type="checkbox" data-id="" data-name=""              data-application="" data-summary="" data-strength="" data-span="" data-spantype="" data-windzone=""              data-roofload="" />            </label>          </td>        </tr>';
            var jsonData = JSON.parse(response);
            // checkGetData(jsonData);
            var dJSON = { products: jsonData },
              directive = {
                tr: {
                  "products<-products": {
                    "#BeamSize": "products.BeamSize",
                    "#reportCheckbox@data-id": "products.JoistsID",
                    "#reportCheckbox@data-name": "products.brandName",
                    "#reportCheckbox@data-application": "products.Application",
                    "#reportCheckbox@data-summary": "products.BeamSize",
                    "#strength": "products.Grade",
                    "#reportCheckbox@data-strength": "products.Grade",
                    "#span": "products.Span",
                    "#reportCheckbox@data-span": "products.Span",
                    "#reportCheckbox@data-spantype": "products.SpanType",
                    "#reportCheckbox@data-windzone": "products.LiveLoad",
                    "#reportCheckbox@data-roofload": "products.JoistCentre",
                  },
                },
              };

            $("#list-rafter").append(clearHTML);
            if (typeof dJSON.products !== "undefined" && dJSON.products.length > 0) {
              document.getElementById("yellowAlert").style.display = "none";
              document.getElementById("reportButton").style.display = "block";
              document.getElementById("tableShell").style.display = "inline-table";
              $("#list-rafter").render(dJSON, directive); //render the result
            } else {
              document.getElementById("yellowAlert").style.display = "block";
              document.getElementById("reportButton").style.display = "none";
              document.getElementById("tableShell").style.display = "none";

              document.getElementById("showResult").innerHTML = "Product is currently not available";
            }
          }

          relevantEventListeners();
        },
        error: function (response) {
          document.getElementById("yellowAlert").style.display = "block";
          document.getElementById("reportButton").style.display = "none";
          document.getElementById("tableShell").style.display = "none";
          document.getElementById("showResult").innerHTML = "Product is currently not available";
        },
      });

      $("#searchContainer").ajaxStart(function () {
        $("#Loading").show();
      });
    }

    function relevantEventListeners() {
      $("#reportCheckbox").myCart({
        currencySymbol: "$",
        classCartIcon: "my-cart-icon1",
        classCartBadge: "my-cart-badge1",
        classProductQuantity: "my-product-quantity",
        classProductRemove: "my-product-remove",
        classCheckoutCart: "my-cart-checkout",
        affixCartIcon: false,
        showCheckoutModal: true,
        numberOfDecimals: 2,
        cartItems: [],
      });
    }

    $("#viewReportlist").on("click", function () {
      var val = [];
      $("#list-rafter input[type=checkbox]:checked").each(function (i) {
        this.setAttribute("checked", ""); // For IE
        this.checked = true;
        val[i] = $(this).val();
      });
      if (val.length === 0) {
        $("#yellowAlert").show();
        document.getElementById("showResult").innerHTML = "Please include a report to view report";
      } else {
        $("#yellowAlert").hide();
        $("#hideonReport").hide();
        $("#myDIV").hide();
        $("#ViewReport").show();

        var dateObj = new Date();
        var month = dateObj.getUTCMonth() + 1; //months from 1-12
        var day = dateObj.getUTCDate();
        var year = dateObj.getUTCFullYear();

        var newdate = "Date created: " + day + "/" + month + "/" + year;

        document.getElementById("getDate").innerHTML = newdate;
      }
    });
    // report button JS
    $("#printReport").on("click touchstart", function () {
      $("#ViewReport").printThis({
        pageTitle: "jQuery printThis Demo",
        loadCSS: "",
      });
    });
    $("#continueEdit").on("click touchstart", function () {
      $("#ViewReport").hide();
      $("#hideonReport").show();
      $("#myDIV").show();
    });
    $("#resetReport").on("click touchstart", function () {
      $("#my-cart-table").empty();
      $("#list-rafter input[type=checkbox]:checked").each(function (i) {
        this.removeAttribute("checked"); // For other browsers
        this.checked = false;
      });
      // $('#list-rafter input[type=checkbox]').attr('checked', false); // Unchecks it
      // $('.viewReportlist').hide();
      $("#reportCheckbox").myCart({
        cartItems: [],
      });
    });

    /*
     * jQuery myCart - v1.7 - 2018-03-07
     * http://asraf-uddin-ahmed.github.io/
     * Copyright (c) 2017 Asraf Uddin Ahmed; Licensed None
     */
    (function ($) {
      // eslint-disable-next-line
      "use strict";

      var OptionManager = (function () {
        var objToReturn = {};

        var _options = null;
        var DEFAULT_OPTIONS = {
          currencySymbol: "$",
          classCartIcon: "my-cart-icon",
          classCartBadge: "my-cart-badge",
          classProductQuantity: "my-product-quantity",
          classProductRemove: "my-product-remove",
          classCheckoutCart: "my-cart-checkout",
          affixCartIcon: true,
          showCheckoutModal: true,
          numberOfDecimals: 2,
          cartItems: null,
          clickOnAddToCart: function ($addTocart) {},
          afterAddOnCart: function (products) {},
          clickOnCartIcon: function ($cartIcon, products) {},
          checkoutCart: function (products) {
            return false;
          },
        };

        var loadOptions = function (customOptions) {
          _options = $.extend({}, DEFAULT_OPTIONS);
          if (typeof customOptions === "object") {
            $.extend(_options, customOptions);
          }
        };
        var getOptions = function () {
          return _options;
        };

        objToReturn.loadOptions = loadOptions;
        objToReturn.getOptions = getOptions;
        return objToReturn;
      })();
      // eslint-disable-next-line
      var MathHelper = (function () {
        var objToReturn = {};
        var getRoundedNumber = function (number) {
          if (isNaN(number)) {
            throw new Error("Parameter is not a Number");
          }
          number = number * 1;
          var options = OptionManager.getOptions();
          return number.toFixed(options.numberOfDecimals);
        };
        objToReturn.getRoundedNumber = getRoundedNumber;
        return objToReturn;
      })();

      var ProductManager = (function () {
        var objToReturn = {};

        /*
        PRIVATE
        */
        localStorage.products = localStorage.products ? localStorage.products : "";
        var getIndexOfProduct = function (id) {
          var productIndex = -1;
          var products = getAllProducts();
          $.each(products, function (index, value) {
            if (value.id === id) {
              productIndex = index;
              return;
            }
          });
          return productIndex;
        };
        var setAllProducts = function (products) {
          localStorage.products = JSON.stringify(products);
        };
        var addProduct = function (id, name, summary, application, strength, span, spantype, windzone, roofload) {
          var products = getAllProducts();
          products.push({
            id: id,
            name: name,
            summary: summary,
            application: application,
            strength: strength,
            span: span,
            spantype: spantype,
            windzone: windzone,
            roofload: roofload,
          });
          setAllProducts(products);
        };

        /*
        PUBLIC
        */
        var getAllProducts = function () {
          try {
            var products = JSON.parse(localStorage.products);
            return products;
          } catch (e) {
            return [];
          }
        };
        var updatePoduct = function (id, quantity) {
          var productIndex = getIndexOfProduct(id);
          if (productIndex < 0) {
            return false;
          }
          // eslint-disable-next-line
          var products = getAllProducts();

          return true;
        };
        var setProduct = function (id, name, summary, application, strength, span, spantype, windzone, roofload) {
          if (typeof id === "undefined") {
            console.error("id required");
            return false;
          }
          if (typeof name === "undefined") {
            console.error("name required");
            return false;
          }

          summary = typeof summary === "undefined" ? "" : summary;
          application = typeof application === "undefined" ? "" : application;
          strength = typeof strength === "undefined" ? "" : strength;
          span = typeof span === "undefined" ? "" : span;
          spantype = typeof spantype === "undefined" ? "" : spantype;
          windzone = typeof windzone === "undefined" ? "" : windzone;
          roofload = typeof roofload === "undefined" ? "" : roofload;

          if (!updatePoduct(id)) {
            addProduct(id, name, summary, application, strength, span, spantype, windzone, roofload);
          }
        };
        var clearProduct = function () {
          setAllProducts([]);
        };
        var removeProduct = function (id) {
          var products = getAllProducts();
          products = $.grep(products, function (value, index) {
            return value.id !== id;
          });
          setAllProducts(products);
        };

        objToReturn.getAllProducts = getAllProducts;
        objToReturn.updatePoduct = updatePoduct;
        objToReturn.setProduct = setProduct;
        objToReturn.clearProduct = clearProduct;
        objToReturn.removeProduct = removeProduct;
        return objToReturn;
      })();

      var loadMyCartEvent = function (targetSelector) {
        var options = OptionManager.getOptions();
        var $cartIcon = $("." + options.classCartIcon);
        // eslint-disable-next-line
        var $cartBadge = $("." + options.classCartBadge);
        // eslint-disable-next-line
        var classProductQuantity = options.classProductQuantity;
        var classProductRemove = options.classProductRemove;
        // eslint-disable-next-line
        var classCheckoutCart = options.classCheckoutCart;
        // eslint-disable-next-line
        var idCartModal = "my-cart-modal";
        var idCartTable = "my-cart-table";
        // eslint-disable-next-line
        var idGrandTotal = "my-cart-grand-total";
        // eslint-disable-next-line
        var idEmptyCartMessage = "my-cart-empty-message";
        // eslint-disable-next-line
        var idDiscountPrice = "my-cart-discount-price";
        // eslint-disable-next-line
        var classProductTotal = "my-product-total";
        // eslint-disable-next-line
        var classAffixMyCartIcon = "my-cart-icon-affix";

        if (options.cartItems && options.cartItems.constructor === Array) {
          ProductManager.clearProduct();
          $.each(options.cartItems, function () {
            ProductManager.setProduct(
              this.id,
              this.name,
              this.summary,
              this.application,
              this.strength,
              this.span,
              this.spantype,
              this.windzone,
              this.roofload,
            );
          });
        }

        var drawTable = function () {
          var $cartTable = $("#" + idCartTable);
          $cartTable.empty();

          var products = ProductManager.getAllProducts();
          $.each(products, function () {
            // var total = this.quantity * this.price;
            // eslint-disable-next-line
            $cartTable.append(
              '<tr title="' +
                this.summary +
                '" data-id="' +
                this.id +
                '">' +
                '<td data-label="Product">' +
                this.name +
                "</td>" +
                '<td data-label="Application">' +
                this.application +
                "</td>" +
                '<td data-label="Beam Size">' +
                this.summary +
                "</td>" +
                '<td data-label="Strength">' +
                this.strength +
                "</td>" +
                '<td data-label="Span Type">' +
                this.spantype +
                "</td>" +
                '<td data-label="Parameter">' +
                this.windzone +
                "," +
                this.roofload +
                "</td>" +
                '<td data-label="Result (mm)">' +
                this.span +
                "</td>" +
                '<td data-label=" " title="Remove from Cart" className="text-center" style="width: 30px;"><a href="javascript:void(0);" className="btn btn-xs btn-danger ' +
                classProductRemove +
                '">X</a></td>' +
                "</tr>",
            );
          });
        };
        var showModal = function () {
          drawTable();
        };

        /*
        EVENT
        */
        // if (options.affixCartIcon) {
        //   var cartIconBottom = $cartIcon.offset().top * 1 + $cartIcon.css("height").match(/\d+/) * 1;
        //   var cartIconPosition = $cartIcon.css('position');
        //   $(window).scroll(function () {
        //     $(window).scrollTop() >= cartIconBottom ? $cartIcon.addClass(classAffixMyCartIcon) : $cartIcon.removeClass(classAffixMyCartIcon);
        //   });
        // }

        $cartIcon.click(function () {
          options.showCheckoutModal ? showModal() : options.clickOnCartIcon($cartIcon, ProductManager.getAllProducts());
        });

        $(document).on("click", "." + classProductRemove, function () {
          var $tr = $(this).closest("tr");
          var id = $tr.data("id");
          $tr.hide(500, function () {
            ProductManager.removeProduct(id);
            $("#list-rafter input[type=checkbox]:checked").each(function (i) {
              var $target = $(this);

              var checkboxDataID = $target.data("id");

              if (checkboxDataID === id) {
                this.removeAttribute("checked"); // For other browsers
                this.checked = false;
              } else {
                this.setAttribute("checked", ""); // For IE
                this.checked = true;
              }
            });
            drawTable();
          });
        });

        $("#list-rafter input[type=checkbox]").on("click", targetSelector, function () {
          if (this.checked) {
            //Do stuff
            var $target = $(this);
            options.clickOnAddToCart($target);
            var id = $target.data("id");
            var name = $target.data("name");
            var summary = $target.data("summary");
            var application = $target.data("application");
            var strength = $target.data("strength");
            var span = $target.data("span");
            var spantype = $target.data("spantype");
            var windzone = $target.data("windzone");
            var roofload = $target.data("roofload");

            ProductManager.setProduct(id, name, summary, application, strength, span, spantype, windzone, roofload);
            options.afterAddOnCart(ProductManager.getAllProducts());
            this.setAttribute("checked", ""); // For IE
            // this.removeAttribute("checked"); // For other browsers
            this.checked = true;
          } else {
            ProductManager.clearProduct();
            this.removeAttribute("checked"); // For other browsers

            // $('#reportCheckbox').attr('checked', false); // Unchecks it
            this.checked = false;
          }
        });
      };

      $.fn.myCart = function (userOptions) {
        OptionManager.loadOptions(userOptions);
        loadMyCartEvent(this.selector);
        return this;
      };
    })($);
  }, []);
  return (
    <div className="col-md-9 col-sm-9">
      <div className="row">
        <div id="hideonReport" style={{ display: "flex", background: "white" }}>
          {/* <!-- Rafter span selection  --> */}
          <div className="col-md-6">
            <h2>Joists</h2>
            <div className="dropdown clearfix position-static" id="spanfilter">
              <p id="errorMessage"></p>
              <label htmlFor="SpanType">Span Type</label>
              <select required="" id="list1">
                <option value="" hidden="">
                  {" "}
                  -- Select Option --{" "}
                </option>
                <option value="Single">Single</option>
                {/* <!--<option value="Continuous">Continuous</option>--> */}
                <option value="Cantilever">Cantilever</option>
              </select>

              <label htmlFor="WindZone">Live Load</label>
              <select required="" id="list2">
                <option value="" hidden="">
                  {" "}
                  -- Select Option --{" "}
                </option>
                <option value="1.5kPa">1.5kPa (1.8kN)</option>
                <option value="2kPa">Residential 2.0kPa (1.8kN)</option>
                <option value="3kPa">Heavy Residential 3.0kPa (1.8kN)</option>
                <option value="4kPa">Commercial 4.0kPa (1.8kN)</option>
              </select>

              <label htmlFor="Roof Load">Joist Centre (mm)</label>
              <select required="" id="list3">
                <option value="" hidden="">
                  {" "}
                  -- Select Option --{" "}
                </option>
                <option value="400">400</option>
                <option value="450">450</option>
                <option value="600">600</option>
              </select>

              <label htmlFor="Desired Span (mm)">Desired Span (mm)</label>

              <input type="text" className="form-control inputSpan" id="desiredSpan" placeholder="Desired Span (mm)" />
              <button className="dropdown-toggle search1" type="submit" id="rafterSubmit">
                Search
              </button>
            </div>
          </div>
          <div className="col-md-6">
            <div className="imgtype">
              <img alt="" src={image} width="100%" />
            </div>
          </div>
        </div>

        {/* <!-- list of span table result --> */}
        <div className="col-md-12" id="myDIV">
          <div id="searchContainer">
            <div id="Loading">
              <i className="fa fa-spinner fa-pulse fa-5x fa-fw"></i>
              <span className="sr-only">Loading...</span>
            </div>
          </div>

          <table id="tableShell">
            <thead>
              <tr>
                <th scope="col">Size</th>
                <th scope="col">Grade</th>
                <th scope="col">Span (mm)</th>
                <th scope="col">Select</th>
              </tr>
            </thead>
            <tbody id="list-rafter">
              <tr>
                <td data-label="Size">
                  <span id="BeamSize"></span>
                </td>
                <td data-label="Grade">
                  <span id="strength" data-strength=""></span>
                </td>
                <td data-label="Span (mm)">
                  <span id="span" data-span=""></span>
                </td>
                <td data-label="Select">
                  <label className="toggle-check">
                    <input
                      id="reportCheckbox"
                      type="checkbox"
                      data-id=""
                      data-name=""
                      data-application=""
                      data-summary=""
                      data-strength=""
                      data-span=""
                      data-spantype=""
                      data-windzone=""
                      data-roofload=""
                    />
                  </label>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="col-md-6 m-auto">
            <div className="viewReportlist mt-4" id="reportButton">
              <span className="my-cart-icon1" id="viewReportlist">
                <p>
                  View Report <span className="badge badge-notify my-cart-badge1"></span>
                </p>
              </span>
            </div>
            <div className="yellowAlert" id="yellowAlert">
              <h4>
                <b id="showResult"></b>{" "}
              </h4>
            </div>
          </div>
        </div>
        <div id="ViewReport">
          <div className="col-md-12 reportBorder">
            <div className="spanTablesTitle" style={{ backgroundColor: "#222" }}>
              <h1>
                <b>Span Tables</b>{" "}
              </h1>
            </div>
            <div className="LogoActions">
              <div className="col-md-4">
                <div className="reportLogo">
                  <img className="header-logo-image" src={DESIGNPINELOGO} alt="Design Pine" />
                </div>
              </div>
              <div className="col-md-8">
                <div className="alightItem">
                  <button id="printReport" className="new-button me-3" type="button" name="button">
                    Print Report
                  </button>
                  <button id="continueEdit" className="new-button me-3" type="button" name="button">
                    Continue Editing Report
                  </button>
                  <button id="resetReport" className="new-button me-3" type="button" name="button">
                    Reset Report
                  </button>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="outputTitle">
                <p>
                  <b className="designPineBlue">DesignPine</b> Span Table List
                </p>
                <p id="getDate"></p>
                <hr />
                <h4>
                  <b>Results</b>{" "}
                </h4>
                <hr />
              </div>

              <div id="output">
                <div className="reportTable">
                  <table>
                    <thead>
                      <tr>
                        <th scope="col">Product</th>
                        <th scope="col">Application</th>
                        <th scope="col">Size</th>
                        <th scope="col">Strength</th>
                        <th scope="col">Span Type</th>
                        <th scope="col">Parameter</th>
                        <th scope="col">Result (mm)</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody id="my-cart-table"></tbody>
                  </table>
                </div>
              </div>

              <div id="showAppReport">
                <div className="col-md-6">
                  <h2>
                    <b>Joists</b>{" "}
                  </h2>
                  <p>Floor dead load 0.4 kPa</p>
                  <p>
                    Deflection limits <br /> Long term: span/300 or 15mm
                    <br /> Short term: span/360 or 9mm
                  </p>
                  <p>
                    <b>Notes</b>{" "}
                  </p>
                  <p>
                    1.Joists designed to provisions of AS 1720.1:2010, Timber Structures.
                    <br /> 2. Timber grade As stated - Wet use. <br /> 3. Spans may be increased by 10% for joists
                    continuous over 2 or more spans.
                    <br /> 4. Blocking required in accordance with AS1684-2010
                  </p>
                </div>
                <div className="col-md-6">
                  <div className="imgtype">
                    {" "}
                    <img alt="" src={image} width="100%" />{" "}
                  </div>
                </div>
              </div>

              <hr />
              <h2>
                <b>Certification</b>{" "}
              </h2>
              <p>
                The above span output is certified by Dave King Eng - Tasman Consulting, reviewed by: Robin Frengley
                Consulting Engineer
              </p>
              <p>
                <b>Disclaimer</b>{" "}
              </p>
              <p>
                ITI takes no responsibility for the interpretation of the above application or the information input
                into the generation of this report. The Above span are applicable for the products described above only.
              </p>
              <p>www.designpine.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Joists;
